const BOX = 'Box';
const DROPBOX = 'Dropbox';
const FACEBOOK = 'Facebook';
const GDRIVE = 'GDrive';
const MAILBOX = 'Mailbox';
const ONE_DRIVE_CONSUMER = 'OneDriveConsumer';
const ONE_DRIVE_PRO = 'OneDrivePro';
const RECENT_ATTACHMENTS = 'RecentAttachments';
const WOPI = 'Wopi';
const WOPI_BOX = 'WopiBox';
const WOPI_EGNYTE = 'WopiEgnyte';

const FileProviderConstants = {
    BOX: BOX,
    DROPBOX: DROPBOX,
    FACEBOOK: FACEBOOK,
    GDRIVE: GDRIVE,
    MAILBOX: MAILBOX,
    ONE_DRIVE_CONSUMER: ONE_DRIVE_CONSUMER,
    ONE_DRIVE_PRO: ONE_DRIVE_PRO,
    RECENT_ATTACHMENTS: RECENT_ATTACHMENTS,
    WOPI: WOPI,
    WOPI_BOX: WOPI_BOX,
    WOPI_EGNYTE: WOPI_EGNYTE,
};

export default FileProviderConstants;
